export default "__VITE_ASSET__iQ1pXj3Q__"